module.exports = __webpack_public_path__ + "assets/boomerang-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/boomerang-icon.svg
// module id = 812
// module chunks = 0